<template>
    <div class="d-flex flex-column page-wrapper accounts">
        <page-header>
            <span v-if="editMode">{{ $t("message.edit" )}}</span> {{ $t("message.accounts" )}}
        </page-header>
        <div class="container d-flex flex-column align-items-center page-container">
            <div class="d-flex flex-row justify-content-around steps-container">
                <div class="dot previous-dot"></div><!-- Identification -->
                <div class="dot previous-dot"></div><!-- Contact Info -->
                <div class="dot previous-dot"></div><!-- Other Info -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Identification -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Contact Info -->
                <div class="dot previous-dot" v-if="jointBorrower == true"/><!-- Joint Other Info -->
                <div class="dot current-dot"></div><!-- Accounts -->
                <div class="dot next-dot"></div><!-- Funding -->
                <div class="dot next-dot"></div><!-- Review -->
            </div>
            <p class="explanation-text">
                We offer a wide variety of accounts to fit your needs, <strong>all you need to do is choose 
                your starting accounts</strong>. Don't worry, you can always add more later<strong>. As a member, 
                you will automatically have a Primary Savings Account</strong>.
            </p>
            <div class="d-flex flex-column justify-content-start align-items-start form-container">
                <b-form @submit.prevent="submit" novalidate>
                    <b-form-group v-for="category in accountCategories" :key="category.coreId">
                        <label class="form-label">{{ category.name }}</label>
                        <b-button-group vertical class="btn-width"> 
                            <b-button variant="primary outline-primary" :pressed="true" disabled v-for="option in requiredAccounts(category.eligibleAccountTypes)" :key="option.coreId">{{ option.name }}<span>(*)</span></b-button>
                            <b-button variant="outline-primary" :pressed="option.selected === true" @click="selectAccount(option)" v-for="option in optionalAccounts(category.eligibleAccountTypes)" :key="option.coreId">{{ option.name }}</b-button>                                                                    
                        </b-button-group>
                    </b-form-group>
                    <div v-for="([service, serviceValue], index) in availableServices" :key="'service'+index">
                        <b-form-group v-if="service === 'DEB'">
                            <label class="form-label">Would you like a debit card?</label>
                            <div class="switch-btn-container">
                                <label :for="$id('debSwitch')" class="switch-btn-left-label">No</label>
                                <b-form-checkbox class="switch-btn" v-model="debitCard" :id="$id('debSwitch')" switch size="lg"></b-form-checkbox>
                                <label :for="$id('debSwitch')" class="switch-btn-right-label">Yes</label>
                            </div>
                        </b-form-group>
                        <b-form-group v-if="service === 'CPY'">
                            <label class="form-label">Courtesy Pay Opt In?</label>
                            <div class="switch-btn-container">
                                <label :for="$id('cpySwitch')" class="switch-btn-left-label">No</label>
                                <b-form-checkbox class="switch-btn" v-model="courtesyPay" :id="$id('cpySwitch')" switch size="lg"></b-form-checkbox>
                                <label :for="$id('cpySwitch')" class="switch-btn-right-label">Yes</label>
                            </div>
                        </b-form-group>
                        <b-form-group v-if="service === 'OTD'">
                            <label class="form-label">Overdraft Transfer Designation?</label>
                            <div class="switch-btn-container">
                                <label :for="$id('otdSwitch')" class="switch-btn-left-label">No</label>
                                <b-form-checkbox class="switch-btn" v-model="overdraftTransferDesignation" :id="$id('otdSwitch')" switch size="lg"></b-form-checkbox>
                                <label :for="$id('otdSwitch')" class="switch-btn-right-label">Yes</label>
                            </div>
                        </b-form-group>
                        <b-form-group v-if="service === 'CDM'">
                            <label class="form-label">CD Maturity Option?</label>
                            <b-button-group vertical class="btn-width">                        
                                <b-button variant="outline-primary" :pressed="option.value === maturity"  @click="selectMaturity(option)" v-for="option in maturityOptions" :key="option.value">{{ option.name }}</b-button>                                                                    
                            </b-button-group>
                        </b-form-group>
                    </div>
                    <div class="d-flex flex-column justify-content-between align-items-center final-action-div">
                        <b-button variant="secondary" type="submit" :for="$id('next')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.next" )}}</span>
                            <span v-if="editMode">{{ $t("message.saveEdit" )}}</span>
                        </b-button>
                        <b-button variant="light" @click="back()" :for="$id('back')" class="btn btn-width">
                            <span v-if="!editMode">{{ $t("message.back" )}}</span>
                            <span v-if="editMode">{{ $t("message.cancel" )}}</span>
                        </b-button>
                    </div>
                </b-form>
            </div>     
        </div>
        <page-footer />
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { mask } from 'vue-the-mask';
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Accounts",
  components: {
    Datepicker
  },
  directives: {
    mask
  },
  props: {},
  created() {
  },
  mounted: function () {
    this.setSelectedAccounts();
    this.setAvailableServices();
  },
  data: function() {
      return {
            selectedAccounts: [],
            availableServices: new Map(),
            selectedServiceIds: [],
            maxAccount: 2,
            maturityOptions: [            
                { name: 'Maturity Option 1', value: 'Maturity Option 1' },
                { name: 'Maturity Option 2', value: 'Maturity Option 2' },
            ],
        };
    },
  computed: {
    ...mapState([
      "editMode",
      "currentState",
      "creditUnion",
      "isJointApplication",
      "accountCategories",
      "accountsToOpen",
      "services",
      "serviceIds",
    ]),
    ...mapGetters([
      'primaryEmploymentHistoryInMonths',
    ]),
    creditUnionName: {
      get() {
        return this.creditUnion.name;
      }
    },
    jointBorrower: {
      get() {
        return this.isJointApplication;
      }
    },
    debitCard: {
        get() {
            return this.$store.state.debitCard.deliveryMethod === "MAIL";
        },
        set(value) {
            this.updateGetDebitCard(value);
        }
    },
    courtesyPay: {
        get() {
            return this.$store.state.courtesyPay;
        },
        set(value) {
            this.updateOptInCourtesyPay(value);
        }
    },
    overdraftTransferDesignation: {
        get() {
            return this.$store.state.overdraftTransferDesignation;
        },
        set(value) {
            this.updateOverdraftTransferDesignation(value);
        }
    },
    maturity: {
        get() {
            return this.$store.state.maturity;
        },
        set(value) {
            this.updateMaturity(value);
        }
    },
  },
  methods: {
    ...mapActions([
        'getIncomeTypes',
    ]),
    ...mapMutations([
        'updateGetDebitCard',
        'updateOptInCourtesyPay',
        'updateOverdraftTransferDesignation',
        'updateMaturity'
    ]),
    setSelectedAccounts() {
        console.log('account categories', this.accountCategories);
        console.log('accounts to open', this.accountsToOpen);
        this.selectedAccounts = this.accountsToOpen;
        for(var i = 0; i < this.accountCategories.length; i++) {
            if(this.accountCategories[i].eligibleAccountTypes) {
                for(var j = 0; j < this.accountCategories[i].eligibleAccountTypes.length; j++) {
                    if(this.accountCategories[i].eligibleAccountTypes[j].required && this.selectedAccounts.findIndex((item) => item.coreId === this.accountCategories[i].eligibleAccountTypes[j].coreId) === -1) {
                        this.selectedAccounts.push(this.accountCategories[i].eligibleAccountTypes[j]);
                        this.accountCategories[i].eligibleAccountTypes[j].selected = true;
                    } else if(this.selectedAccounts.findIndex((item) => item.coreId === this.accountCategories[i].eligibleAccountTypes[j].coreId) != -1) {
                        this.accountCategories[i].eligibleAccountTypes[j].selected = true;
                    }
                }
            }
        }
    },
    setAvailableServices() {
        console.log('services', this.services);
        console.log('selected services', this.availableServices);
        this.availableServices = this.services;
        this.selectedServiceIds = this.serviceIds;
    },
    requiredAccounts(accountTypes) {
        var accounts = [];
            for(var i = 0; i < accountTypes.length; i++) {
                if(accountTypes[i].required === true) {
                    accounts.push(accountTypes[i]);
                }
            }
        return accounts;
    },
    optionalAccounts(accountTypes) {
        var accounts = [];
            for(var i = 0; i < accountTypes.length; i++) {
                if(accountTypes[i].required !== true) {
                    accounts.push(accountTypes[i]);
                }
            }
        return accounts;
    },
    selectAccount(opt) {
        opt.selected = !opt.selected;
        let vm = this
        if(opt.selected === true) {
            vm.selectedAccounts.push(opt);
            let services = opt.eligibleAccountServices;
            if(services) {
                services.forEach(service => {
                    let selectedService = this.availableServices.get(service.serviceId);
                    if(selectedService) {
                        console.log('already in map')
                        selectedService.push(opt.coreId); //add the account id to the array 
                        this.availableServices.set(service.serviceId, selectedService);
                        console.log(this.availableServices)
                    } else {
                        // add to list of selected services. The availableServices map is only used for UI manipulation.
                        this.availableServices.set(service.serviceId, [opt.coreId]);
                        // add to list of selected service Ids. This array will be sent back with the application.
                        this.selectedServiceIds.push(service.coreId);
                        console.log(this.availableServices)
                    }
                });
            }
        } else {
            var index = vm.selectedAccounts.findIndex((item) => { item === opt });
            vm.selectedAccounts.splice(index, 1);
            let services = opt.eligibleAccountServices;
            if(services) {
                services.forEach(service => {
                    let serviceId = this.availableServices.get(service.serviceId);       
                    console.log(serviceId)              
                    let index = serviceId.findIndex((item) => { return item === opt.coreId });
                    serviceId.splice(index, 1);      
                        console.log('after slice')
                        console.log(serviceId)
                        if(serviceId.length === 0) {
                            // remove from list of selected services      
                            this.availableServices.delete(service.serviceId); 
                            // remove from list of selected service Ids      
                            var serviceIdIndex = this.selectedServiceIds.findIndex((item) => { return item === service.coreId });
                            this.selectedServiceIds.splice(serviceIdIndex, 1);      
                        } else {
                            this.availableServices.set(service.serviceId, serviceId);
                        }
                        console.log('after after slice')
                        console.log(this.availableServices)
                });
            }
        }
    },
    selectMaturity(opt) {
        this.maturity = opt.value;
    },
    async submit() {
        if(this.editMode) {
            this.$router.push("review");
        } else {
            this.$router.push("funding");
        }
    },
    back() {
        if(this.editMode) {
            this.$store.replaceState(this.currentState);
            this.$router.push("review");
        } else if (this.jointBorrower) {
            this.$router.push("jointotherinformation");
        } else {
            this.$router.push('otherinformation');
        }
    },
  },
};
</script>